import { c as _c } from "react/compiler-runtime";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import LeadWallBudgetFirstStep from "@modules/application/components/LeadWall/LeadWallBudgetCheck";
import useApplicationContext from "@modules/application/hooks/useApplicationContext";
import usePostBudgetCheckWithLead from "@modules/application/hooks/usePostBudgetCheckWithLead";
import { BudgetCheckFormValues } from "@modules/application/lib/budgetCheck/types";
import { FC } from "react";
import { FormStepComponent } from "../FormSteps/FormSteps";
const BudgetCheckLeadWall: FC<FormStepComponent<BudgetCheckFormValues>> = t0 => {
  const $ = _c(15);
  const {
    value,
    onPrevious,
    onNext
  } = t0;
  const {
    state,
    dispatch
  } = useApplicationContext();
  const {
    partner
  } = usePartnerContext();
  const t1 = value as BudgetCheckFormValues;
  let t2;
  if ($[0] !== dispatch || $[1] !== onNext) {
    t2 = (maximumBudget, lead) => {
      dispatch({
        type: "SET_LEAD",
        lead
      });
      dispatch({
        type: "SET_MAXIMUM_BUDGET",
        maximumBudget
      });
      onNext();
    };
    $[0] = dispatch;
    $[1] = onNext;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== partner || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      partner,
      budgetCheckForm: t1,
      onSuccess: t2,
      leadCreationAction: "MAXIMUM_BUDGET_CONTACT_WALL"
    };
    $[3] = partner;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    isError,
    isLoading,
    handleSubmit
  } = usePostBudgetCheckWithLead(t3);
  let t4;
  if ($[7] !== onPrevious) {
    t4 = () => onPrevious();
    $[7] = onPrevious;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== handleSubmit || $[10] !== isError || $[11] !== isLoading || $[12] !== state.lead || $[13] !== t4) {
    t5 = <><div className="col-span-5"><LeadWallBudgetFirstStep onSubmit={handleSubmit} isError={isError} isLoading={isLoading} defaultValues={state.lead} onPrevious={t4} /></div></>;
    $[9] = handleSubmit;
    $[10] = isError;
    $[11] = isLoading;
    $[12] = state.lead;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export default BudgetCheckLeadWall;